import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form } from "react-bootstrap";
import moment from "moment";
import countryList from "react-select-country-list";
import placeholder from "../../assets/images/userprofile.png";
import { blobToFile, scrollToFirstError } from "../../utils/helpers";
import ImageCropper from "../../Component/ImageCropper";
import SkeletonLoader from "./skeltonLoader";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";

// Redux Toolkit imports
import {
  fetchUserProfile,
  fetchUniversityPartners,
  fetchIndustries,
  fetchProgramStudies,
  fetchUpdateProfileSettings,
  fetchAreas,
  fetchObjectives,
  fetchParticularPrograms,
  fetchLanguages,
  fetchExperience,
  updateProfileStep,
  clearStepFields,
} from "./Slice/updateProfileSliceNew";
import {
  fetchCoursesCompleted,
  fetchBoardExperienceMentor,
  fetchBoardEntityTypeExperience,
  fetchAccreditedDirector,
  fetchBoardExperienceLevel,
  fetchBoardExperience,
} from "../Authentication/Register/slice/registerSlice";
import {
  normalizeUpdateProfilePayload,
  buildUpdateProfileFormData,
  applyUserProfileData,
  handlePostProfileLoadEffects,
} from "./helpers/updateProfile/updateProfileDataHelpers";
import { renderUpdateProfileField, renderBoardRolesInline } from "./helpers/updateProfile/updateProfileFieldRenderers";
import PropTypes from "prop-types";

const UpdateProfileStep1 = (props) => {
  const dispatch = useDispatch();

  // Redux state from the slice
  const {
    universityPartners: university_partners_list,
    industries: industry_list,
    programStudies: programStudyId,
    updateProfileStepFields: registerStepFields,
    areas,
    objectives: objective,
    particularPrograms: particularProgram,
    languages: languageOptions,
    experienceData: userExperience,

  } = useSelector((state) => state.updateProfile);

  // Board-related data from register slice
  const {
    coursesCompleted,
    boardExperienceMentor,
    boardEntityTypeExperience,
    accreditedDirector,
    boardExperienceLevel,
    boardExperience,
  } = useSelector((state) => state.register);

  // Component-specific loading state to prevent flash
  const [componentReady, setComponentReady] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Other Redux state
  const { setting } = useSelector((state) => state.setting);

  const { userInfo } = useSelector((state) => state.userInfo);
  const programmes = useSelector((state) => state.programmes);
  const updateProfileData = useSelector((state) => state.updateProfileData);

  const location = useLocation();
  const history = useNavigate();
  const { title, superUserParams } = props;

  const [dob, setDob] = useState(null);
  const {
    register,
    control,
    reset,
    clearErrors,
    handleSubmit,
    setValue,
    watch,
    formState,
    formState: { errors },
    trigger
  } = useForm({
    defaultValues: superUserParams,
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const queryStringParsed = new URLSearchParams(location.search);
  const [roleId, setRoleId] = useState("");
  const [checkBox, setCheckBox] = useState(false);
  const [checkBox2, setCheckBox2] = useState(false);
  const [showDateDiv, setShowDateDiv] = useState("none");
  const [experience, setExperience] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [emailVerifyString, setEmailVerifyString] = useState("");
  const [readOnly, setReadOnly] = useState(false);
  const [industryData, setIndustryData] = useState("");

  const [{ alt, src }, setImg] = useState({
    src: placeholder,
    alt: "Upload an Image",
  });
  const [cropImg, setCropImg] = useState("");
  const [cropImgModalShow, setCropImgModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [userId, setUserId] = useState(userInfo?.id);
  const options = countryList().getData();
  const [country] = useState(options);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [userData, setUserData] = useState({});
  const [redirectPath, setRedirectPath] = useState(null);
  const [mainArea, setMainArea] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedObjective, setSelectedObjective] = useState([]);
  const [selectedResume, setSelectedResume] = useState("");
  const [resumeText, setResumeText] = useState("");
  const [text, setText] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [available, setAvailable] = useState("");
  const [email, setEmail] = useState(queryStringParsed.email);
  const [gender, setGender] = useState("");
  const [employee, setEmployee] = useState("");
  const [settingData, setSettingData] = useState([]);

  console.log("", text);

  const customStyles = {
    menu: (base) => ({
      ...base,
      backgroundColor: "white",
      top: "32px",
      borderRadius: "8px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
    }),
  };

  const countWords = (text) => {
    return text?.replaceAll("\r\n", "\n")?.length;
  };

  const getUniversityPartnerList = () => dispatch(fetchUniversityPartners());
  const getIndustryList = () => dispatch(fetchIndustries());
  const getProgramStudyId = () => dispatch(fetchProgramStudies());
  const registerSetting = (roleId1) => dispatch(fetchUpdateProfileSettings(roleId1));
  const getAreasData = () => dispatch(fetchAreas());
  const getObjectiveData = (roleID) => dispatch(fetchObjectives(roleID));
  const getParticularProgram = () => dispatch(fetchParticularPrograms());
  const getLanguageList = () => dispatch(fetchLanguages());
  const getExperienceData = () => dispatch(fetchExperience());

  const currentYear = new Date().getFullYear();
  const years = Array.from(new Array(currentYear - 1990 + 1), (val, index) => 1990 + index);
  const checkFromDate = (date) => {
    const formattedDate = moment(new Date(date)).format("YYYY-MM-DD");
    setFromDate(formattedDate);
    setValue("from_date", formattedDate);
  };

  const checkToDate = (date) => {
    const formattedDate = moment(new Date(date)).format("YYYY-MM-DD");
    setToDate(formattedDate);
    setValue("to_date", formattedDate);
  };


  const showDatePicker = (e) => {
    if (e.target.checked) {
      setAvailable(2);
      setShowDateDiv("block");
    } else {
      setAvailable(1);
      setShowDateDiv("none");
    }
  };

  const handleChange = (item) => {
    getExperienceData();
    setRoleId(item);

    // Fetch board-related data based on role
    if (item === "Mentor" || item === "Mentees") {
      dispatch(fetchCoursesCompleted());
      dispatch(fetchBoardExperience(item));
      dispatch(fetchBoardExperienceLevel(item));
      dispatch(fetchBoardEntityTypeExperience(item));
      dispatch(fetchAccreditedDirector(item));
      dispatch(fetchBoardExperienceMentor("Mentee")); // Always call with "Mentee" for board_entity_type_2
    }
  };

  const handleProgrammesChange = (item) => {
    // Program study ID is handled by react-hook-form
    if (item) {
      clearErrors("program_study_id");
    }
  };

  const handleGender = (value) => {
    setGender(value);
  };

  const setOrganizationPlaceholder = (e) => {
    const val = typeof e === "string" ? e : e?.target?.value;
    setEmployee(val);
    setValue("employee", val, { shouldValidate: true });
    if (val?.toLowerCase() === "yes") {
      setValue("employee_end_date", "");
      clearErrors("employee_end_date");
    } else if (val?.toLowerCase() !== "no") {
      setValue("employee_start_date", "");
      setValue("employee_end_date", "");
      clearErrors(["employee_start_date", "employee_end_date"]);
    }
  };


  useEffect(() => {
    if (formState.submitCount > 0 && Object.keys(errors).length > 0) {
      scrollToFirstError();
    }
  }, [formState.submitCount, errors]);

  const onSubmit = async (data) => {
    const empVal = (data.employee || employee || "")?.toLowerCase();
    if (empVal !== "yes" && empVal !== "no") {
      clearErrors(["employee_start_date", "employee_end_date"]);
      setValue("employee_start_date", "");
      setValue("employee_end_date", "");
      data.employee_start_date = "";
      data.employee_end_date = "";
    } else if (empVal === "yes") {
      clearErrors("employee_end_date");
      setValue("employee_end_date", "");
      data.employee_end_date = "";
    }
    const isValid = await trigger();
    if (!isValid) {
      scrollToFirstError();
      return;
    }
    const normalizedPayload = normalizeUpdateProfilePayload({
      data: { ...data, step_number: "step_1" },
      roleId,
      available,
      fromDate,
      toDate,
      email_verify_string: emailVerifyString,
      selectedResume,
      selectedFile,
    });

    const formData = buildUpdateProfileFormData({
      data: normalizedPayload,
      registerStepFields,
      selectedFile,
    });

    setIsLoading(true);

    dispatch(updateProfileStep({
      params: formData,
      step: "step_1",
      userId: userId,
      redirectPath: null
    }))
      .unwrap()
      .then((response) => {
        setIsLoading(false);
        if (response.success) {
          setPopupMessage(response.message);
          setShowPopup(true);
          if (response.redirectTo) {
            setRedirectPath(response.redirectTo);
          }
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setPopupMessage(error.message || "Update failed");
        setShowPopup(true);
      });
  };

  const handlePopupOk = () => {
    setShowPopup(false);
    if (redirectPath) {
      dispatch(clearStepFields());
      history(redirectPath);
    }
  };

  useEffect(() => {
    getUniversityPartnerList();
    getIndustryList();
    getParticularProgram();
    getAreasData();
    getProgramStudyId();
    if (languageOptions.length === 0) {
      getLanguageList();
    }
  }, [setting]);

  useEffect(() => {
    if (queryStringParsed?.email) {
      setValue("email", queryStringParsed.email);
    }
  }, [queryStringParsed?.email]);


  const handleApprovalRedirect = ({
    settingResponse,
    verificationData,
    history,
    message,
    setPopupMessage,
    setShowPopup,
  }) => {
    const adminApprovalRequired =
      settingResponse?.data?.data?.admin_approval_required === 1;

    const emailApprovalRequired =
      settingResponse?.data?.data?.email_approval_required === 1;

    if (!adminApprovalRequired || !emailApprovalRequired) {
      return;
    }

    const {
      email_verfication_status,
      role_id,
      first_name,
    } = verificationData;

    if (
      email_verfication_status === 1 &&
      role_id &&
      first_name
    ) {
      setPopupMessage(message);
      setShowPopup(true);
      history("/");
    }
  };
  const applyVerifyEmailResponse = ({
    res,
    setValue,
    setRoleId,
    handleChange,
    setEmail,
    setReadOnly,
    setEmailVerifyString,
    getObjectiveData,
    registerSetting,
    setUserId,
    setPopupMessage,
    setShowPopup,
  }) => {
    const data = res.data.data;

    setValue("role_id", data.role_id);
    setRoleId(data.role_id);
    handleChange(data.role_id);

    setEmail(data.email);
    setValue("email", data.email);

    setReadOnly(true);
    setEmailVerifyString(data.email_verify_string);

    getObjectiveData(data.role_id);
    registerSetting(data.role_id);

    setUserId(data.id);
    setPopupMessage(res.data.message);
    setShowPopup(true);

    return data;
  };

  const initSettings = async () => {
    try {
      const settingResponse = await agent.get(API.SETTING);
      setSettingData(settingResponse?.data || []);
      const validatingString = queryStringParsed?.validating_string;
      if (!validatingString) return;

      if (userInfo?.id) {
        history("manage-profile");
        return;
      }

      try {
        const res = await agent.get(API.VERIFY_EMAIL, {
          params: { validating_string: validatingString },
        });

        const verificationData = applyVerifyEmailResponse({
          res,
          setValue,
          setRoleId,
          handleChange,
          setEmail,
          setReadOnly,
          setEmailVerifyString,
          getObjectiveData,
          registerSetting,
          setUserId,
          setPopupMessage,
          setShowPopup,
        });

        handleApprovalRedirect({
          settingResponse,
          verificationData,
          history,
          message: res.data.message,
          setPopupMessage,
          setShowPopup,
        });

      } catch (err) {
        setPopupMessage(err.message);
        setShowPopup(true);
      }

    } catch (error) {
      console.error("Error in initSettings:", error);
    }
  };


  useEffect(() => {
    initSettings();
  }, [props?.step]);

  useEffect(() => {
    if (!updateProfileData?.id) {
      // Brand-new user: no profile exists yet — show the empty form, not the skeleton
      handlePostProfileLoadEffects({
        setComponentReady,
        setInitialDataLoaded,
      });
      return;
    }

    dispatch(fetchUserProfile(updateProfileData?.id))
      .unwrap()
      .then((res) => {
        const userData = res.data;
        setUserData(userData);

        applyUserProfileData({
          userData,
          reset,
          setRoleId,
          setDob,
          setSelectedObjective,
          getObjectiveData,
          registerSetting,
          setEmailVerifyString,
          setText,
          setResumeText,
          setSelectedResume,
          setExperience,
          setValue,
          setMainArea,
          setSelectedArea,
          clearErrors,
          setImg,
          setAvailable,
          setShowDateDiv,
          checkFromDate,
          checkToDate,
          setSelectedFile,
          getExperienceData,
          setEmployee,
          setGender,
          setCountry: setSelectedCountry,
          languageOptions,
          blobToFile,
          placeholder,
          dispatch,
          fetchCoursesCompleted,
          fetchBoardExperience,
          fetchBoardExperienceLevel,
          fetchBoardEntityTypeExperience,
          fetchAccreditedDirector,
          fetchBoardExperienceMentor,
        });

        handlePostProfileLoadEffects({
          setComponentReady,
          setInitialDataLoaded,
        });
      })
      .catch((err) => {
        console.error(err);
        handlePostProfileLoadEffects({
          setComponentReady,
          setInitialDataLoaded,
        });
      });
  }, [title, setting, updateProfileData?.id]);

  useEffect(() => {
    if (areas.length > 0 && userData?.domains) {
      const tempMain = userData.domains
        ? userData.domains.split(",").map(String)
        : [];
      const tempSub = userData.subareas
        ? userData.subareas.split(",").map(String)
        : [];

      setMainArea(tempMain);
      setSelectedArea(tempSub);
      setValue("mainArea", tempMain);
      setValue("subarea", tempSub);
      setValue("domains", tempMain);
    }
  }, [areas, userData]);

  const onChangePicture = (e) => {
    if (e.target.files[0]) {
      const file = e?.target?.files[0];
      const allowedExtensions = ['jpg', 'jpeg', 'png'];
      const fileExtension = file?.name?.split('.')?.pop()?.toLowerCase();
      const isAllowedExtension = allowedExtensions?.includes(fileExtension);

      if (!isAllowedExtension) {
        setPopupMessage('Please select valid image format');
        setShowPopup(true);
        return;
      }

      const size = file.size / (1024 * 1024);
      if (size > 30) {
        setPopupMessage('Please select image size less than 30 MB');
        setShowPopup(true);
        setImg({
          src: placeholder,
          alt: "Upload an Image"
        });
        return;
      }

      clearErrors('image');
      setImg({
        src: placeholder,
        alt: file.name,
      });
      setCropImg(URL.createObjectURL(file));
      setCropImgModalShow(true);
      setIsLoading(false);
    } else {
      setImg({
        src: placeholder,
        alt: "Upload an Image",
      });
      setIsLoading(true);
    }
  };

  const fileToImage = (childdata) => {
    const croppedFile = blobToFile(
      childdata,
      updateProfileData?.id + ".png"
    );

    setSelectedFile(croppedFile);
    setImg({
      src: URL.createObjectURL(childdata),
      alt: "",
    });

    setValue("image", croppedFile, {
      shouldDirty: true,
      shouldValidate: true,
    });

    trigger("image");
    setCropImgModalShow(false);
  };

  const onChangeResume = (e) => {
    if (e.target.files[0]) {
      const selectedResume = e.target.files[0];
      setSelectedResume(selectedResume);
      setResumeText(selectedResume.name);
      clearErrors('resume');
    }
  };


  const renderField = (field) =>

    renderUpdateProfileField(field,
      {
        control,
        register,
        errors,
        watch,
        setValue,
        clearErrors,
        trigger,
        formState,
        email,
        setEmail,
        readOnly,
        email_verify_string: emailVerifyString,
        roleId,
        handleChange,
        handleProgrammesChange,
        programmes,
        programStudyId,
        university_partners_list,
        years,
        userExperience,
        experience,
        setExperience,
        country,
        country1: selectedCountry,
        setCountry: setSelectedCountry,
        userData,
        languageOptions,
        customStyles,
        industry_list,
        industryData,
        setIndustryData,
        particularProgram,
        checkBox,
        setCheckBox,
        checkBox2,
        setCheckBox2,
        available,
        showDateDiv,
        checkFromDate,
        checkToDate,
        fromDate,
        toDate,
        setShowDateDiv,
        showDatePicker,
        onChangePicture,
        selectedFile,
        src,
        alt,
        placeholder,
        resumeText,
        onChangeResume,
        mainArea,
        setMainArea,
        selectedArea,
        setSelectedArea,
        areas,
        selectedObjective,
        setSelectedObjective,
        objective,
        dob,
        setDob,
        countWords,
        setText,
        employee: employee || watch("employee") || "",
        setOrganizationPlaceholder,
        gender,
        handleGender,
        selectedResume,
        // Board-related data
        coursesCompleted,
        boardExperienceMentor,
        boardEntityTypeExperience,
        accreditedDirector,
        boardExperienceLevel,
        boardExperience,
        setting: settingData?.data || setting,
        settingData,
        setResumeText,
        setSelectedResume,
        dispatch
      });

  useEffect(() => {
    if (selectedObjective.length > 0) {
      setValue("objective", selectedObjective);
      clearErrors("objective");
      trigger("objective");
    }
  }, [selectedObjective]);

  return (
    <>
      <section>
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col md={10} className="mb-3">
              <div
                className="logininnerouter resetouter"

              >
                {(!componentReady || !initialDataLoaded) && <SkeletonLoader />}

                <div style={{ display: (componentReady && initialDataLoaded) ? 'block' : 'none' }}>
                  {registerStepFields?.map((resp) => {
                    return (
                      <div
                        key={resp.id}
                        className="loginform"
                        style={{ backgroundColor: "white" }}
                      >
                        <Form onSubmit={handleSubmit(onSubmit, () => scrollToFirstError())}>
                          <Row className="align-items-start justify-content-start">
                            {(() => {
                              // Track which board role fields have been rendered
                              let renderedBoardRoleFields = new Set();

                              return (
                                <>
                                  {resp?.reg_feilds?.map((field) => {
                                    const boardRoleFieldKeys = ['rep_company_name', 'rep_board_title', 'rep_start_date', 'rep_end_date', 'rep_label'];
                                    const isBoardRoleField = boardRoleFieldKeys.includes(field.reg_key);

                                    // Skip if already rendered as part of a group
                                    if (renderedBoardRoleFields.has(field.reg_key)) {
                                      return null;
                                    }

                                    // If this is the first board role field, render the entire group
                                    if (isBoardRoleField && field.reg_key === 'rep_company_name') {
                                      renderedBoardRoleFields.add('rep_company_name');
                                      renderedBoardRoleFields.add('rep_board_title');
                                      renderedBoardRoleFields.add('rep_start_date');
                                      renderedBoardRoleFields.add('rep_end_date');

                                      return (
                                        <React.Fragment key="board_roles_group">
                                          {renderBoardRolesInline(resp?.reg_feilds, {
                                            control,
                                            register,
                                            errors,
                                            watch,
                                            setValue,
                                            clearErrors,
                                            trigger,
                                            roleId,
                                            setting: settingData?.data || setting,
                                            formState,
                                          })}
                                        </React.Fragment>
                                      );
                                    }

                                    // Skip other board role fields (they're rendered as a group)
                                    if (isBoardRoleField) {
                                      return null;
                                    }

                                    // Render normal fields
                                    return (
                                      <React.Fragment key={field.reg_key}>
                                        {renderField(field)}
                                      </React.Fragment>
                                    );
                                  })}

                                  <Col md={12}>
                                    <div className="form-group mt-3">
                                      <button
                                        type="submit"
                                        disabled={isLoading}
                                        className="btn btn_red w-100 loginsubmit"
                                      >
                                        {isLoading ? "Submitting..." : "Save & Next"}{" "}
                                      </button>
                                    </div>
                                  </Col>
                                </>
                              );
                            })()}
                          </Row>
                        </Form>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {cropImgModalShow && (
        <ImageCropper
          show={cropImgModalShow}
          cropImg={cropImg}
          fileToImage={fileToImage}
          onHide={() => {
            setCropImgModalShow(false);
          }}
          centered
          size="xl"
          className="cropper-modal"
        />
      )}

      <PopupModalWithOk
        show={showPopup}
        onHide={handlePopupOk}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </>
  );
}
UpdateProfileStep1.propTypes = {
  title: PropTypes.string,
  superUserParams: PropTypes.object,
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};


export default UpdateProfileStep1;
